export interface CensusEnums {
    censusEquipmentStatuses: CensusEquipmentStatuses;
    censusEquipmentStatusDetails: CensusEquipmentStatusDetails;
    actions: Actions;
    censusEquipmentStatusReasons: CensusEquipmentStatusReasons;
    descriptions: CensusEquipmentStatuses & CensusEquipmentStatusDetails & CensusEquipmentStatusReasons;
}

export interface CensusEquipmentStatuses {
    OK: string;
    WARNING: string;
    FAIL: string;
}

export interface CensusEquipmentStatuses {
    OK: string;
    WARNING: string;
    FAIL: string;
}

export interface CensusEquipmentStatusDetails {
    NO_TELEMETRY_DATA: string;
    WRITTEN_OFF: string;
    UL: string;
    IN_WAREHOUSE: string;
    NO_NETWORK: string;
    WITH_WARNING: string;
    MISSING: string;
    TO_BE_VISITED: string;
    SEASONAL: string;
}

export interface Actions {
    STATUS_TO_BE_VISITED: string;
    STATUS_MISSING_AND_LOCK: string;
    HEARTBEAT_CHECK: string;
    NO_ACTION: string;
    MULTIPLE_SELECTIONS: string;
}

export enum CensusEquipmentStatusesEnum {
    OK = "OK",
    WARNING = "WARNING",
    FAIL = "FAIL",
}

export enum CensusEquipmentStatusDetailsEnum {
    NO_TELEMETRY_DATA = "NO_TELEMETRY_DATA",
    WRITTEN_OFF = "WRITTEN_OFF",
    UL = "UL",
    IN_WAREHOUSE = "IN_WAREHOUSE",
    NO_NETWORK = "NO_NETWORK",
    WITH_WARNING = "WITH_WARNING",
    MISSING = "MISSING",
    TO_BE_VISITED = "TO_BE_VISITED",
    SEASONAL = "SEASONAL",
}

export enum ActionsEnum {
    STATUS_TO_BE_VISITED = "STATUS_TO_BE_VISITED",
    STATUS_MISSING_AND_LOCK = "STATUS_MISSING_AND_LOCK",
    HEARTBEAT_CHECK = "HEARTBEAT_CHECK",
    MULTIPLE_SELECTIONS = "MULTIPLE_SELECTIONS",
    NO_ACTION = "NO_ACTION",
    MANUAL_CHECK = "MANUAL_CHECK",
}

export enum CensusEquipmentStatusReasons {
    EQUIPMENT_STATUS = "EQUIPMENT_STATUS",
    WITH_UM_ALARM = "WITH_UM_ALARM",
    NOT_TRANSMITTING_SINCE_LONG_TIME = "NOT_TRANSMITTING_SINCE_LONG_TIME",
    WITH_VBCTK = "WITH_VBCTK",
    OTHER = "OTHER",
}
